// frontend/src/components/layout/Sidebar.js (نسخه هوشمند و کشویی)

import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
    FaTachometerAlt, FaPlusCircle, FaTasks, FaUserGraduate, 
    FaCog, FaUsersCog, FaSitemap, FaChevronDown,
    FaBookOpen
} from 'react-icons/fa';

const Sidebar = () => {
    const userRole = localStorage.getItem('userRole');
    const location = useLocation(); // برای تشخیص مسیر فعلی

    // State برای کنترل منوی باز شده
    const [openMenu, setOpenMenu] = useState('');

    // تابع برای باز و بسته کردن منوها
    const handleToggle = (menuName) => {
        setOpenMenu(openMenu === menuName ? '' : menuName);
    };

    // ========= تعریف ساختار منوها =========
    const teacherMenuItems = [
        { to: "/teacher/dashboard", icon: <FaTachometerAlt />, text: "داشبورد" },
        { to: "/teacher/courses", icon: <FaBookOpen />, text: "مدیریت دوره‌ها" }, // ✅ اضافه کردن این خط
        { to: "/teacher/assignments/create", icon: <FaPlusCircle />, text: "ایجاد تکلیف" },
        { to: "/teacher/assignments", icon: <FaTasks />, text: "مدیریت تکالیف" },
        { to: "/teacher/students", icon: <FaUserGraduate />, text: "دانش‌آموزان" },
    ];

    const adminMenuItems = [
        { to: "/admin/dashboard", icon: <FaTachometerAlt />, text: "داشبورد کلان" },
        { 
            text: "مدیریت کاربران", // این آیتم والد است
            icon: <FaUsersCog />, 
            children: [ // آیتم‌های فرزند
                { to: "/admin/users", text: "لیست کاربران" },
                { to: "/admin/users/add", text: "افزودن کاربر جدید" },
            ] 
        },
        { to: "/admin/organizations", icon: <FaSitemap />, text: "مدیریت سازمان‌ها" },
    ];

    const menuItems = userRole === 'Teacher' ? teacherMenuItems : adminMenuItems;

    // بررسی اینکه آیا مسیر فعلی زیرمجموعه یک منو هست یا نه
    const isParentActive = (item) => {
        return item.children && item.children.some(child => location.pathname.startsWith(child.to));
    };

    return (
        <aside className="sidebar">
            <div className="sidebar-header">
                <h1 className="sidebar-logo">سُهات</h1>
            </div>
            <nav className="sidebar-nav">
                <ul>
                    {menuItems.map((item, index) => (
                        <li key={index} className={item.children ? 'nav-item-parent' : ''}>
                            {item.children ? (
                                // اگر آیتم فرزند داشت (منوی کشویی)
                                <div 
                                    className={`nav-link ${isParentActive(item) ? 'active-parent' : ''}`}
                                    onClick={() => handleToggle(item.text)}
                                >
                                    {item.icon}
                                    <span>{item.text}</span>
                                    <FaChevronDown className={`chevron ${openMenu === item.text || isParentActive(item) ? 'open' : ''}`} />
                                </div>
                            ) : (
                                // اگر آیتم ساده بود
                                <NavLink to={item.to} className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                    {item.icon}
                                    <span>{item.text}</span>
                                </NavLink>
                            )}
                            
                            {/* نمایش زیرمنو در صورت باز بودن */}
                            {item.children && (openMenu === item.text || isParentActive(item)) && (
                                <ul className="submenu">
                                    {item.children.map((child, childIndex) => (
                                        <li key={childIndex}>
                                            <NavLink to={child.to} className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                                <span>{child.text}</span>
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </nav>
            <div className="sidebar-footer">
                <ul>
                    <li>
                        <NavLink to="/settings" className="nav-link">
                            <FaCog />
                            <span>تنظیمات</span>
                        </NavLink>
                    </li>
                </ul>
            </div>
        </aside>
    );
};

export default Sidebar;